import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import ScriptFlowStepHeaderContainer from 'common/ScriptFlowStepHeaderContainer';
import ScriptFlowStepFooter from 'common/ScriptFlowStepFooter';

const classString = classNames({
  'vra-script-flow-body': true
});

const ScriptFlowBody = ({
  canGoBack,
  canGoForward,
  children,
  isAdvancedScripting,
  isExperimentScripting,
  isFinalStep,
  isMultiLayerEnabled,
  onClickBack,
  onClickForward,
  showFooter=true
}) => {
  return (
    <section className={classString}>
      <ScriptFlowStepHeaderContainer
        isAdvancedScripting={isAdvancedScripting}
      />
      {children?.type && children}
      {
        showFooter
        && <ScriptFlowStepFooter
          canGoBack={canGoBack}
          canGoForward={canGoForward}
          isAdvancedScripting={isAdvancedScripting}
          isExperimentScripting={isExperimentScripting}
          isFinalStep={isFinalStep}
          isMultiLayerEnabled={isMultiLayerEnabled}
          isVisible={showFooter}
          onClickBack={onClickBack}
          onClickForward={onClickForward}
        />
      }
    </section>
  );
};
ScriptFlowBody.propTypes = {
  canGoBack: propTypes.bool,
  canGoForward: propTypes.bool,
  children: propTypes.node.isRequired,
  isAdvancedScripting: propTypes.bool,
  isExperimentScripting: propTypes.bool,
  isFinalStep: propTypes.bool.isRequired,
  isMultiLayerEnabled: propTypes.bool.isRequired,
  onClickBack: propTypes.func,
  onClickForward: propTypes.func,
  showFooter: propTypes.bool
};
export default ScriptFlowBody;
